export const trackSnapchatEvents = (eventName, eventValues) => {
  if (typeof (window as any).snaptr !== 'undefined') {
    (window as any).snaptr('track', eventName, {
      ...eventValues
    });
  }
};
